<template>
  <div class="content-ct">
    <el-row v-if="selectedChannels.length > 0">
      <el-col :xs="9" :sm="9" :md="8" :lg="4">
        <campaign-content-nav
          :selected-channels="selectedChannels"
          :channels="channels"
          :multi-variant="model.ab"
          :variants="model.variants"
          :multi-lang="model.languages_multi"
          :languages="model.languages_list"
          :model="model"
          :languages-default="model.languages_default"
        />
      </el-col>
      <el-col
        :xs="15"
        :sm="15"
        :md="16"
        :lg="20"
        :class="{
          workflow: model.type === campaignTypeEnum.TYPE_WORKFLOW && !model.ab
        }"
      >
        <campaign-content-page v-model="model" />
      </el-col>
    </el-row>
    <el-alert
      v-else
      :title="$t('CampaignStep_Content_Title_SelectChannel')"
      type="info"
      :description="$t('CampaignStep_Content_Title_SelectChannel_Description')"
      show-icon
      :closable="false"
    >
    </el-alert>
    <div v-if="model.type !== campaignTypeEnum.TYPE_WORKFLOW" class="footer">
      <div
        :class="{ noChannelSelected: selectedChannels.length === 0 }"
        class="footer-ct"
      >
        <el-button type="primary" @click="nextStep" data-qa="next-step-btn">
          {{ nextBtnLabel }}
          <i class="el-icon-arrow-right el-icon-right"></i>
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { channelLabels } from '@/modules/campaign-manage/enum/Labels'
import CampaignContentNav from '@/modules/campaign-manage/components/content/CampaignContentNav'
import CampaignContentPage from '@/modules/campaign-manage/components/content/CampaignContentPage'
import { campaignTypeEnum } from '@/modules/campaigns/enum/CampaignTypeEnum'
import { EventBus } from '@/core/EventBus'
import { campaignTriggerTypes } from '@/modules/campaign-manage/enum/CampaignTriggerTypesEnum'
export default {
  name: 'StepContent',

  components: {
    CampaignContentNav,
    CampaignContentPage
  },

  props: {
    model: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      activeItem: null,
      channelLabels,
      campaignTypeEnum,
      campaignTriggerTypes
    }
  },

  computed: {
    channels() {
      return {
        ...channelLabels,
        inapp: 'CampaignForm_ChannelsSelect_Inapp',
        workflow: 'CampaignForm_ChannelsSelect_Workflow'
      }
    },

    selectedChannels() {
      if (this.model.type === campaignTypeEnum.TYPE_WORKFLOW) {
        return ['workflow']
      }

      let result = Object.keys(this.channels).filter(c => this.model[c] === 1)

      return [...new Set(result)]
    },

    nextBtnLabel() {
      if (this.model.trigger === campaignTriggerTypes.TRIGGER_LOCATION) {
        return this.$t('CampaignForm_Content_NextButton_Title_Locations')
      }

      if (this.model.trigger === campaignTriggerTypes.TRIGGER_EVENT) {
        return this.$t('CampaignForm_Content_NextButton_Title_Events')
      }

      return this.$t('CampaignForm_Content_NextButton_Title_Segment')
    }
  },

  methods: {
    nextStep() {
      EventBus.$emit('campaign-create-next-step')
    }
  }
}
</script>

<style scoped>
.workflow {
  width: 100%;
}

.noChannelSelected {
  margin-top: 20px;
}
.content-ct {
  padding-bottom: 60px;
}
.footer {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 60px;
  background: #ffffff;
  z-index: 1;
  border-top: 1px solid #e5e5e5;
}
.footer-ct {
  margin-right: 20px;
  margin-bottom: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/pages/StepContent.vue